module.exports = __webpack_public_path__ + "components/resort-webcams/static/no-webcam-59e38126a20642494692b4dfd5bde068.jpg";